"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _coreCreatStore = _interopRequireDefault(require("../../coreProduct/coreCreatStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
var _default = exports.default = {
  name: 'ProductProductAdd',
  components: {
    storeCreate: _coreCreatStore.default
  }
};